import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { DefaultSelection } from 'src/app/models/default-selection.model';

export interface DefaultSelectionState extends EntityState<DefaultSelection> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'defaultSelection' })
export class DefaultSelectionStore extends EntityStore<DefaultSelectionState, DefaultSelection> {
  constructor() {
    super();
  }
}
